
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import Editor from 'wangeditor'
import MaterialSelect from '@/components/material-select/index.vue'
import { getRandomString } from '@/utils/util'
import config from '@/config'
@Component({
    components: {
        MaterialSelect
    }
})
export default class LsEditor extends Vue {
    $refs!: { materialSelect: any }

    /** S Props **/
    @Prop() value: any

    @Prop({
        default: () => [
            'head',
            'bold',
            'fontSize',
            'fontName',
            'italic',
            'underline',
            'strikeThrough',
            'indent',
            'lineHeight',
            'foreColor',
            'link',
            'list',
            'justify',
            'quote',
            'emoticon',
            'image',
            'video',
            'undo',
            'redo'
        ]
    })
    menu!: string[]
    @Prop({ default: 400 }) height!: number
    @Prop() width!: number
    /** E Props **/

    firstData = true
    editor: any = null
    identify = ''

    get editStyle() {
        return this.width ? { width: `${this.width}px` } : {}
    }

    @Watch('value')
    valueChange(val: string) {
        if (!this.editor) return
        if (this.firstData && val !== this.editor.txt.html()) {
            this.firstData = false
            this.editor.txt.html(val || '')
        }
    }

    handeleChange(val: any) {
        const list = Array.isArray(val) ? val : val ? [val] : []
        list.forEach((src: string) => {
            this.editor.cmd.do('insertHTML', `<img src="${src}" style="max-width:100%;"/>`)
        })
    }

    created() {
        this.identify = 'editor' + '-' + getRandomString(3)
    }

    mounted() {
        this.editor = new Editor(`#${this.identify}`)
        this.editor.config.height = this.height
        this.editor.config.menus = this.menu
        this.editor.config.menuTooltipPosition = 'down'
        this.editor.config.showFullScreen = false
        this.editor.config.showLinkImg = false
        this.editor.config.uploadImgShowBase64 = true
        this.editor.config.zIndex = 1
        this.editor.config.uploadImgFromMedia = () => {
            this.$refs.materialSelect.showDialog()
        }
        this.editor.config.onchange = (newHtml: string) => {
            this.$emit('input', newHtml)
        }
        this.editor.config.uploadVideoServer = `${config.baseURL}/platformapi/upload/video`
        this.editor.config.uploadVideoHeaders = {
            token: this.$store.getters.token,
            version: config.version
        }
        this.editor.config.uploadVideoName = 'file'
        this.editor.config.uploadVideoHooks = {
            fail: () => {
                this.$message.error('上传视频失败')
            },
            timeout: () => {
                this.$message.error('上传视频超时')
            },
            customInsert: (insertVideoFn: any, result: any) => {
                if (result.code == 1) {
                    insertVideoFn(result.data.uri)
                } else {
                    this.$message.error(result.msg)
                }
            }
        }
        this.editor.create()
        if (this.value) {
            this.editor.txt.html(this.value)
            this.firstData = false
        }
    }

    beforeDestroy() {
        if (this.editor) this.editor.destroy()
    }
}
